import { c as _c } from "react/compiler-runtime";
import type { ResourceOperatorFieldsFragment } from '@/modules/__generated__/graphql/switchboard-generated';
import { OperatorCard } from '@/modules/services/components/operator-card';
interface SelectOperatorStepProps {
  onSelectOperator: (operatorId: string) => void;
  operator: ResourceOperatorFieldsFragment;
}
function SelectOperatorStep(t0) {
  const $ = _c(4);
  const {
    onSelectOperator,
    operator
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-2"><span className="text-foreground text-base/6 font-semibold lg:text-lg/5.5 lg:font-bold">Operator</span><span className="text-foreground text-xs/4.5 lg:text-base/6">Choose the operator that will manage your subscription. Your selected operator will handle day-to-day service administration, including billing adjustments and usage limit changes. Click "Configure Services" to proceed with your preferred operator.</span></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onSelectOperator || $[2] !== operator) {
    t2 = <div className="flex flex-col gap-6 md:gap-8">{t1}<div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2"><OperatorCard operator={operator} onSelectOperator={onSelectOperator} /></div></div>;
    $[1] = onSelectOperator;
    $[2] = operator;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export { SelectOperatorStep };